module.exports = __webpack_public_path__ + "static/media/logo_sm.8e676962.png";